@if (!child) {
  <div
    class="mega-branch-trigger"
    [ngClass]="{
      'fuse-horizontal-navigation-menu-active': megaOpen,
      'fuse-horizontal-navigation-menu-active-forced':
        item.active || hasActiveChild,
    }"
    (click)="toggleMegaMenu(); $event.stopPropagation()"
    #triggerRef
  >
    <ng-container
      *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
    ></ng-container>
  </div>
}

<ng-template #megaTemplate>
  <div
    class="app-mega-menu-shell"
    tabindex="-1"
    role="menu"
    (click)="onPanelClick($event)"
    (keydown)="onMegaMenuKeydown($event)"
  >
    <div class="app-mega-menu-grid">
      @for (lane of lanes; track trackLane($index, lane)) {
        <div
          class="app-mega-menu-lane"
          [ngClass]="'app-mega-menu-lane--tone-' + ($index % 6)"
        >
          @for (col of lane; track trackCol($index, col)) {
            <div class="app-mega-menu-column">
              <div class="app-mega-menu-column-heading">{{ col.title }}</div>
              @for (section of col.sections; track $index) {
                @if (section.subtitle) {
                  <div class="app-mega-menu-subheading">{{ section.subtitle }}</div>
                }
                @for (link of section.links; track trackLink($index, link)) {
                  @if (link.link && !link.externalLink && !link.disabled) {
                    <a
                      class="app-mega-menu-link"
                      [routerLink]="link.link"
                      [queryParams]="link.queryParams ?? undefined"
                      [fragment]="link.fragment ?? undefined"
                      [queryParamsHandling]="link.queryParamsHandling ?? undefined"
                      routerLinkActive="app-mega-menu-link--active"
                      [routerLinkActiveOptions]="{
                        exact: link.exactMatch ?? false,
                      }"
                      (click)="onInternalLinkClick($event, link)"
                    >
                      <span>{{ link.title }}</span>
                    </a>
                  } @else if (link.link && link.externalLink) {
                    <a
                      class="app-mega-menu-link"
                      [attr.href]="link.link"
                      [attr.target]="link.target || '_blank'"
                      (click)="onLinkClick()"
                    >
                      <span>{{ link.title }}</span>
                    </a>
                  }
                }
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template let-item #itemTemplate>
  <div
    class="fuse-horizontal-navigation-item-wrapper"
    [class.fuse-horizontal-navigation-item-has-subtitle]="!!item.subtitle"
    [ngClass]="item.classes?.wrapper"
  >
    <div
      class="fuse-horizontal-navigation-item"
      [ngClass]="{
        'fuse-horizontal-navigation-item-disabled': item.disabled,
        'fuse-horizontal-navigation-item-active-forced': item.active,
      }"
      [matTooltip]="item.tooltip || ''"
    >
      @if (item.icon) {
        <mat-icon
          class="fuse-horizontal-navigation-item-icon"
          [ngClass]="item.classes?.icon"
          [svgIcon]="item.icon"
        ></mat-icon>
      }
      <div class="fuse-horizontal-navigation-item-title-wrapper">
        <div class="fuse-horizontal-navigation-item-title">
          <span [ngClass]="item.classes?.title">{{ item.title }}</span>
        </div>
        @if (item.subtitle) {
          <div
            class="fuse-horizontal-navigation-item-subtitle text-hint"
          >
            <span [ngClass]="item.classes?.subtitle">{{
              item.subtitle
            }}</span>
          </div>
        }
      </div>
      @if (item.badge) {
        <div class="fuse-horizontal-navigation-item-badge">
          <div
            class="fuse-horizontal-navigation-item-badge-content"
            [ngClass]="item.badge.classes"
          >
            {{ item.badge.title }}
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
